/**
 * Uniqify array and remove undefined and nulls
 */
const unique = <T>(input: T[]): T[] =>
    Array.from(
        new Set<T>(
            input.filter(item => typeof item !== "undefined" && item !== null)
        )
    );
const uniqueBy = <T, V>(input: T[], iteratee: (item: T) => V): T[] => {
    const uniqified = input.reduce((result, item) => {
        const value = iteratee(item);
        if (result.has(value)) {
            return result;
        }
        result.set(value, item);
        return result;
    }, new Map<V, T>());

    return Array.from(uniqified.values());
};
export { unique, uniqueBy };
